import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon, TrendingUpIcon } from 'lucide-react';
const names = ['Lucas', 'Matías', 'Nicolás', 'Franco', 'Diego', 'Sebastián', 'Martín', 'Ezequiel', 'Facundo', 'Agustín', 'Joaquín', 'Tomás', 'Santiago', 'Ignacio', 'Manuel'];
// CIUDADES de Argentina (no provincias)
const cities = ['Buenos Aires', 'Córdoba Capital', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta Capital', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén Capital', 'Santiago del Estero', 'Corrientes Capital', 'Posadas', 'Bahía Blanca', 'Paraná', 'Formosa Capital', 'San Luis Capital', 'Catamarca Capital', 'La Rioja Capital', 'Río Cuarto', 'Comodoro Rivadavia', 'San Salvador de Jujuy', 'Concordia', 'San Nicolás', 'Tandil', 'Zárate', 'Quilmes', 'Lanús', 'Avellaneda', 'San Isidro'];
const messages = ['acaba de unirse a Método Barber Pro', 'está transformando su carrera con Método Barber Pro', 'compró Método Barber Pro', 'se sumó a la formación profesional', 'eligió profesionalizarse con Método Barber Pro'];
const messagesWithColorimetria = ['compró el pack completo: Método Barber Pro + Colorimetría', 'se llevó Método Barber Pro + Colorimetría', 'eligió la formación completa con Colorimetría', 'invirtió en su futuro: Método Barber Pro + Colorimetría'];
function getRandomItem<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)];
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [hasColorimetria, setHasColorimetria] = useState(false);
  useEffect(() => {
    const showPopup = () => {
      const name = getRandomItem(names);
      const city = getRandomItem(cities);
      const includesColorimetria = Math.random() > 0.65;
      setHasColorimetria(includesColorimetria);
      const messageTemplate = includesColorimetria ? getRandomItem(messagesWithColorimetria) : getRandomItem(messages);
      const newMessage = `${name} de ${city} ${messageTemplate}`;
      setMessage(newMessage);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    const interval = setInterval(showPopup, 12000);
    const initialDelay = setTimeout(showPopup, 4000);
    return () => {
      clearInterval(interval);
      clearTimeout(initialDelay);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 right-6 bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-2xl border-2 border-[#c41e3a] p-5 max-w-sm z-50 animate-fade-in" role="status" aria-live="polite" data-id="element-206">
      <div className="flex items-start gap-3" data-id="element-207">
        <div className="bg-[#c41e3a] rounded-full p-2 flex-shrink-0" data-id="element-208">
          {hasColorimetria ? <TrendingUpIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-209" /> : <CheckCircleIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-210" />}
        </div>
        <div className="flex-1" data-id="element-211">
          <p className="text-gray-900 font-bold text-base leading-relaxed" data-id="element-212">
            {message}
          </p>
          <p className="text-[#c41e3a] text-sm mt-1 font-bold" data-id="element-213">
            🔥 Hace unos momentos
          </p>
        </div>
        <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-[#c41e3a] transition-colors" aria-label="Cerrar notificación" data-id="element-214">
          <XIcon className="w-5 h-5" aria-hidden="true" data-id="element-215" />
        </button>
      </div>
    </div>;
}